import React from 'react';
import { UserRowContainer, UserName } from './style';
import { ProfileAvatar } from '../../ProfileAvatar/ProfileAvatar';
import { Text } from '../../../UI/Text';
import { StyledButton } from '../../forms/style';
import { config } from '../../../../Configurations';

export const UserRow = ({ user, onAdd, onEdit }) => {
    return (
        <UserRowContainer>
            <ProfileAvatar size={'medium'} src={`${config.baseUrl}/${user.smallImage}`} />
            <UserName>
                <Text>{user.fullName}</Text>
            </UserName>
            {onAdd && (
                <StyledButton type={'button'} onClick={() => onAdd(user)}>
                    ADD
                </StyledButton>
            )}
            {onEdit && (
                <StyledButton type={'button'} onClick={onEdit}>
                    EDIT
                </StyledButton>
            )}
        </UserRowContainer>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/UserRow/UserRow.js